/** Map a strava_activities list row to the slim shape used by compare / similar lists. */
export function mapActivityRowToSimilarCard(a) {
  return {
    id: a.id,
    name: a.name,
    start_date: a.start_date,
    start_date_local: a.start_date_local,
    distance_km: a.distance ? (parseFloat(a.distance) / 1000).toFixed(2) : null,
    pace_min_per_km:
      a.average_speed && parseFloat(a.average_speed) > 0
        ? (1000 / parseFloat(a.average_speed) / 60).toFixed(2)
        : null,
    session_type: null,
    region_name: null,
  };
}
